import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../../service/authentication.service';
import { ActivatedRoute } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Rate } from '../../../model/Rate';
import { UpdateRatesComponent } from './update-rates/update-rates.component';
import { MultiOrderPipe } from '../../../shared/multi.order.pipe';
import { RatesService } from '../../../service/rates.service';
import { UtilsService } from '../../../service/utils.service';
import { DarkModeService } from '../../../service/dark-mode.service';

@Component({
  selector: 'ch-rates',
  templateUrl: './rates.component.html'
})
export class RatesComponent implements OnInit {

  order = {};
  rates: Array<Rate>;
  orderedRates: Array<Rate>;

  constructor(private readonly authenticationService: AuthenticationService,
              private readonly activatedRoute: ActivatedRoute,
              private readonly modalService: BsModalService,
              private readonly multiOrderPipe: MultiOrderPipe,
              public readonly darkModeService: DarkModeService,
              private readonly rateService: RatesService
  ) { }

  ngOnInit(): void {
   this.rates = this.activatedRoute.snapshot.data['preload'];
   this.order = {
     currencyPair: 1
   };
   this.initFilteredAndOrderedList();
  }


  updateRates(rate: Rate) {
    const initialState = {
      rate
    };
    const modalRef = this.modalService.show(UpdateRatesComponent, {
      backdrop: true,
      ignoreBackdropClick: false,
      class: 'modal-dialog-centered' + UtilsService.getModalDarkModeClass(this.darkModeService),
      animated: false,
      initialState
    });

    modalRef.content.rateUpdated.subscribe(() => {
      this.rateService.getRates().subscribe((rates) => {
        this.rates = rates;
        this.initFilteredAndOrderedList();
        modalRef.hide();
      });
    });
  }

  initFilteredAndOrderedList(): void {
    this.orderedRates = this.multiOrderPipe.transform(this.rates, this.order);
  }

  setOrder(value: string) {
    const existingOrders = Object.keys(this.order).length;
    if (!Object.keys(this.order).includes(value) || this.order[value].value === 0) {
      this.order[value] = {value: 1, order: this.order[value] ? this.order[value].order : existingOrders + 1};
      this.initFilteredAndOrderedList();
      return;
    }

    if (this.order[value].value === 1) {
      this.order[value] = {value: -1, order: this.order[value] ? this.order[value].order : existingOrders + 1};
      this.initFilteredAndOrderedList();
      return;
    }
    // this.order[value] = {value: 0, order: this.order[value] ? this.order[value].order : existingOrders + 1};

    Object.keys(this.order).forEach(k => {
      if (k === value) {
        return;
      }

      if (this.order[value].order < this.order[k].order) {
        this.order[k].order--;
      }
    });
    delete this.order[value];
    this.initFilteredAndOrderedList();
    // this.order[value] = 0;
  }

  getClass(property: string) {
    if (!this.order[property]?.value || this.order[property]?.value === 0) {
      return 'icon-width';
    }
    if (this.order[property]?.value === -1) {
      return 'fa-angle-up';
    }
    return 'fa-angle-down';
  }
}
